(function () {
  function addedMessage() {
    var live = document.getElementById('custom-cart-added-live');
    return (live && live.getAttribute('data-message')) || 'המוצר נוסף לעגלה';
  }

  function pulseCartIcon() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    bubble.classList.remove('custom-cart-added');
    window.requestAnimationFrame(function () {
      bubble.classList.add('custom-cart-added');
    });
    window.setTimeout(function () {
      bubble.classList.remove('custom-cart-added');
    }, 900);
  }

  function showAddedFlash() {
    var message = addedMessage();
    var existing = document.querySelector('.custom-cart-added-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'custom-cart-added-toast';
    toast.setAttribute('aria-hidden', 'true');
    toast.innerHTML =
      '<span class="custom-cart-added-toast__mark">' +
      '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M7.5 12.4l2.8 2.8 6.2-6.4"/></svg>' +
      '</span><span class="custom-cart-added-toast__text"></span>';
    toast.querySelector('.custom-cart-added-toast__text').textContent = message;
    document.body.appendChild(toast);
    window.setTimeout(function () {
      if (toast.parentNode) toast.remove();
    }, 1800);
  }

  function showAddedConfirmation() {
    var live = document.getElementById('custom-cart-added-live');
    pulseCartIcon();
    showAddedFlash();
    if (!live) return;
    var message = addedMessage();
    live.textContent = '';
    window.setTimeout(function () {
      live.textContent = message;
    }, 30);
  }

  function productImage() {
    return (
      document.querySelector('.product__media-item.is-active img') ||
      document.querySelector('.product__media img') ||
      document.querySelector('.product-media-container img')
    );
  }

  function flyToCart() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var img = productImage();
    var cart = document.querySelector('#cart-icon-bubble') || document.querySelector('a.header__icon--cart');
    showAddedConfirmation();
    if (reduce || !img || !cart) return;

    var from = img.getBoundingClientRect();
    var to = cart.getBoundingClientRect();
    var ghost = img.cloneNode(true);
    var size = Math.min(from.width, 140);
    ghost.removeAttribute('srcset');
    ghost.className = 'custom-cart-fly';
    ghost.style.left = from.left + (from.width - size) / 2 + 'px';
    ghost.style.top = from.top + 'px';
    ghost.style.width = size + 'px';
    ghost.style.height = size + 'px';
    document.body.appendChild(ghost);

    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + size / 2);
    window.requestAnimationFrame(function () {
      ghost.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.12)';
      ghost.style.opacity = '0.2';
    });
    window.setTimeout(function () {
      ghost.remove();
    }, 700);
  }

  function patchCartNotification() {
    var Ctor = window.customElements && customElements.get('cart-notification');
    if (!Ctor || Ctor.prototype.__rootineQuietCart) return;
    Ctor.prototype.open = function () {
      flyToCart();
    };
    Ctor.prototype.close = function () {};
    Ctor.prototype.__rootineQuietCart = true;
  }

  patchCartNotification();
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-notification').then(patchCartNotification);
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('a.header__icon--cart');
      if (!link) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      event.stopPropagation();
      window.location.assign(link.href);
    },
    true
  );
})();
